var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkPending(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 115,
    viewBox: "0 0 158 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.4979 113.915C102.498 113.915 125.198 91.2154 125.198 63.1154C125.198 35.0154 102.498 12.3154 74.4979 12.3154C46.4979 12.3154 23.7979 35.0154 23.7979 63.1154C23.7979 91.2154 46.4979 113.915 74.4979 113.915Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9357 43.0829C83.9357 50.4311 77.9932 56.3736 70.5811 56.3736C70.4533 56.3736 69.367 56.3736 61.3798 56.3736C55.8206 56.3736 46.9388 56.3736 32.7535 56.3736H25.9803C17.0985 56.5653 10.0059 49.4727 10.0059 40.9103C10.0059 32.2841 17.1624 25.1276 26.172 25.5749C33.9037 1.42147 69.3031 4.80805 72.3063 29.7921C78.9517 30.6228 83.9357 36.2458 83.9357 43.0829Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1144 29.8564C71.6032 29.7925 71.092 29.7925 70.5808 29.7925C67.961 29.7925 65.469 30.5593 63.3604 31.9011",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1144 29.8564C71.6032 29.7925 71.092 29.7925 70.5808 29.7925C67.961 29.7925 65.469 30.5593 63.3604 31.9011",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1721 25.5747C25.4054 27.875 25.022 30.3031 25.022 32.8591C25.022 33.8814 25.0859 34.8399 25.2137 35.7984",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1721 25.5747C25.4054 27.875 25.022 30.3031 25.022 32.8591C25.022 33.8814 25.0859 34.8399 25.2137 35.7984",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.695 78.6366C156.695 86.8065 150.088 93.4135 141.847 93.4135C141.705 93.4135 140.497 93.4135 131.617 93.4135C125.436 93.4135 115.561 93.4135 99.7897 93.4135H92.2592C82.3843 93.6266 74.4985 85.7409 74.4985 76.2212C74.4985 66.6304 82.4553 58.6737 92.4723 59.171C101.068 32.3169 140.426 36.0822 143.765 63.8598C151.153 64.7833 156.695 71.0351 156.695 78.6366Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M143.552 63.9309C142.983 63.8599 142.415 63.8599 141.847 63.8599C138.934 63.8599 136.163 64.7124 133.819 66.2043",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M143.552 63.9309C142.983 63.8599 142.415 63.8599 141.847 63.8599C138.934 63.8599 136.163 64.7124 133.819 66.2043",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4721 59.1709C91.6196 61.7284 91.1934 64.428 91.1934 67.2697C91.1934 68.4064 91.2644 69.4721 91.4065 70.5377",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4721 59.1709C91.6196 61.7284 91.1934 64.428 91.1934 67.2697C91.1934 68.4064 91.2644 69.4721 91.4065 70.5377",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7721 95.8018C70.7721 100.169 67.2405 103.7 62.8355 103.7C62.7596 103.7 62.114 103.7 57.3672 103.7C54.0635 103.7 48.785 103.7 40.3548 103.7H36.3295C31.0511 103.814 26.8359 99.5992 26.8359 94.5106C26.8359 89.3841 31.0891 85.131 36.4434 85.3968C41.0383 71.0426 62.076 73.0552 63.8608 87.9031C67.8101 88.3968 70.7721 91.7385 70.7721 95.8018Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7469 87.9413C63.4431 87.9033 63.1393 87.9033 62.8355 87.9033C61.2786 87.9033 59.7976 88.359 58.5444 89.1565",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7469 87.9413C63.4431 87.9033 63.1393 87.9033 62.8355 87.9033C61.2786 87.9033 59.7976 88.359 58.5444 89.1565",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4433 85.397C35.9876 86.764 35.7598 88.2071 35.7598 89.726C35.7598 90.3336 35.7977 90.9032 35.8737 91.4729",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4433 85.397C35.9876 86.764 35.7598 88.2071 35.7598 89.726C35.7598 90.3336 35.7977 90.9032 35.8737 91.4729",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8556 44.0546L64.2607 49.3702C63.031 50.2874 61.4253 49.6337 61.0493 48.0628L58.8478 32.8115",
    fill: "#D6DCE8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M133.884 5.50727L129.646 9.42809L85.2993 50.7697C83.2785 52.7066 80.1533 52.6243 78.0697 50.8394L62.1376 36.1759L58.9417 33.2039L50.1297 24.9329C48.242 23.1011 49.1035 19.7807 51.6961 19.3677L124.586 7.31757L133.884 5.50727Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M133.884 5.50742L129.647 9.42824L62.2866 35.9328L58.8949 33.0077L124.735 7.0745L133.884 5.50742Z",
    fill: "#D6DCE8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0907 88.7678L8.26651 91.172C7.73904 91.588 7.02851 91.3207 6.84546 90.6375L5.70256 83.9877",
    fill: "#D6DCE8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.226 71.1544L36.4174 72.9204L17.492 91.5375C16.6302 92.4091 15.2613 92.4098 14.3283 91.653L7.18225 85.4218L5.74846 84.1585L1.79409 80.6418C0.946275 79.8621 1.28433 78.3986 2.41429 78.1874L34.1778 72.0561L38.226 71.1544Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2262 71.1544L36.4175 72.9204L7.24465 85.3136L5.7257 84.0731L34.2402 71.9478L38.2262 71.1544Z",
    fill: "#D6DCE8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1145 99.271L60.9434 103.673C59.9775 104.435 58.6766 103.945 58.3414 102.694L56.2487 90.5186",
    fill: "#D6DCE8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M115.799 67.0206L112.488 70.2542L77.8348 104.342C76.2569 105.938 73.7504 105.939 72.0421 104.554L58.9575 93.1444L56.3322 90.8313L49.0917 84.392C47.5393 82.9645 48.1583 80.2849 50.2273 79.8981L108.387 68.6716L115.799 67.0206Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M115.799 67.0205L112.487 70.2541L59.0715 92.9462L56.2903 90.6749L108.501 68.4734L115.799 67.0205Z",
    fill: "#D6DCE8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkPending);
export default __webpack_public_path__ + "static/media/SparkPending.4ddedf8fb83aef48969992c7e5e3811d.svg";
export { ForwardRef as ReactComponent };